module.exports = __webpack_public_path__ + "img/amex_card_icon.523f2bc1.png";